module.exports = __webpack_public_path__ + "static/img/iconmenu10.ca58668d.svg";